var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto bg-gray-100"},[_c('router-view',{attrs:{"id":"router-view"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }